import { Visitor, VisitorPhone } from 'entities/Visitor/interfaces';
import {
  GET_VISITORS_REQUEST,
  GET_VISITORS_ERROR,
  GET_VISITORS_SUCCESS,
  GET_VISITOR_PHONES_ERROR,
  GET_VISITOR_PHONES_SUCCESS,
  GET_VISITOR_PHONES_REQUEST,
  GET_VISITOR_PHONE_DELETE,
  GET_VISITOR_DELETE,
  GET_VISITOR_PHONE_ADD,
  GET_VISITOR_ADD_OR_UPDATE,
  GET_VISITOR_PHONE_LATEST,
} from './constants';

export const getVisitorsRequest = (fio?: string, number?: string) => ({
  type: GET_VISITORS_REQUEST,
  payload: { fio, number },
});

export const getVisitorsSuccess = (visitors: Visitor[]) => ({
  type: GET_VISITORS_SUCCESS,
  payload: { visitors },
});

export const getVisitorsError = (error: Error | null) => ({
  type: GET_VISITORS_ERROR,
  payload: { error },
});

export const getVisitorPhonesRequest = (visitorId: number) => ({
  type: GET_VISITOR_PHONES_REQUEST,
  payload: { visitorId },
});

export const getVisitorPhonesSuccess = (phones: VisitorPhone[]) => ({
  type: GET_VISITOR_PHONES_SUCCESS,
  payload: { phones },
});

export const getVisitorPhonesError = (error: Error | null) => ({
  type: GET_VISITOR_PHONES_ERROR,
  payload: { error },
});

export const getVisitorPhoneDelete = (numberId: number, visitorId: number) => ({
  type: GET_VISITOR_PHONE_DELETE,
  payload: { numberId, visitorId },
});

export const getVisitorPhoneLatest = (numberId: number, visitorId: number) => ({
  type: GET_VISITOR_PHONE_LATEST,
  payload: { numberId, visitorId },
});

export const getVisitorPhoneAdd = (visitorId: number, data: any) => ({
  type: GET_VISITOR_PHONE_ADD,
  payload: { visitorId, data },
});

export const getVisitorDelete = (visitorId: number, fio?: string, number?: string) => ({
  type: GET_VISITOR_DELETE,
  payload: { visitorId, fio, number },
});

export const getVisitorsAddOrUpdate = (visitor: any, fio?: string, number?: string) => ({
  type: GET_VISITOR_ADD_OR_UPDATE,
  payload: { visitor, fio, number },
});

export type Actions =
  | ReturnType<typeof getVisitorsError>
  | ReturnType<typeof getVisitorsSuccess>
  | ReturnType<typeof getVisitorsRequest>
  | ReturnType<typeof getVisitorsAddOrUpdate>
  | ReturnType<typeof getVisitorPhonesError>
  | ReturnType<typeof getVisitorPhonesSuccess>
  | ReturnType<typeof getVisitorPhonesRequest>
  | ReturnType<typeof getVisitorPhoneDelete>
  | ReturnType<typeof getVisitorPhoneAdd>
  | ReturnType<typeof getVisitorDelete>;
